<div class="confirmation-dialog">

    <div class="dialog-header">
        Cancel Order
    </div>

    <div class="dialog-body">

        <table class="table table-borderless mb-3">

            <tr>
                <td class="td_font text-left">Order Amount</td>
                <td class="td_font text-right">
                    ₹ {{ totalAmount | number:'1.2-2' }}
                </td>
            </tr>

            <tr>
                <td class="td_font text-left">Cancellation Deduction</td>
                <td class="td_font text-right text-danger">
                    {{dialogData.refundSetup.deductionPercentage || 0}} %
                    (₹ {{ deductionAmount | number:'1.2-2'}})
                </td>
            </tr>

            <tr>
                <td class="td_font text-left">Refund Amount</td>
                <td class="td_font text-right text-success">
                    ₹ {{ refundAmount | number:'1.2-2'}}
                </td>
            </tr>

            <tr>
                <td class="td_font text-left">Refund To</td>
                <td class="td_font text-right">

                    {{dialogData.refundSetup.refundMode=='WALLET'
                    ? 'Wallet'
                    : 'Original Payment Method'}}

                </td>
            </tr>

        </table>

        <div *ngIf="!dialogData.refundSetup.refundApplicable" class="alert alert-warning">

            No refund is applicable for this cancellation.

        </div>

        <div *ngIf="dialogData.refundSetup.refundApplicable" class="alert alert-info">

            By proceeding, your order will be cancelled and the refund
            will be processed as shown above.

        </div>

    </div>

    <div class="dialog-footer">

        <button mat-stroked-button class="confirm_btn" (click)="onBack()">

            Back

        </button>

        <button mat-stroked-button color="primary" class="confirm_btn" style="float: right; width: 110px !important;"
            (click)="onProceed()">

            Proceed

        </button>

    </div>

</div>